import { useState } from 'react';
import { ICONS, followLink } from '@/lib/homeLayout';
import { useNavigate } from 'react-router-dom';
import { Leaf } from 'lucide-react';

export default function DesktopAbout({ s, theme }) {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const facilities = s.facilities || [];
  const shown = showAll ? facilities : facilities.slice(0, 8);
  const heading = { fontFamily: theme.heading_font, color: s.text_color || theme.primary_color };

  return (
    <section className="py-10 lg:py-16" style={{ background: s.bg_color, fontFamily: theme.body_font }}>
      <div className="px-4 md:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-10 lg:gap-12">
        <div>
          <h2 className="text-3xl font-bold mb-4" style={heading}>{s.title}</h2>
          <p className="leading-relaxed mb-8 whitespace-pre-line" style={{ color: s.text_color || theme.primary_color }}>{s.description}</p>
          <h3 className="text-xl font-bold mb-3" style={heading}>{s.hours_title}</h3>
          <dl className="space-y-1.5 mb-8">
            {(s.hours || []).map((h, i) => (
              <div key={i} className="flex justify-between gap-4 border-b border-black/10 pb-1.5 text-sm" style={{ color: s.text_color || theme.primary_color }}>
                <dt className="font-semibold">{h.day}</dt><dd>{h.time}</dd>
              </div>
            ))}
          </dl>
          <button onClick={() => followLink(s.button_link || '/ContactUs', navigate)} className="mr-3 mb-3 px-7 py-3 rounded-md text-white font-bold uppercase tracking-wide" style={{ background: theme.primary_color }}>
            {s.button_text || 'Contact Us'}
          </button>
          {facilities.length > 8 && (
            <button onClick={() => setShowAll(!showAll)} className="px-6 py-2.5 rounded-md text-white font-bold uppercase text-sm tracking-wide" style={{ background: theme.primary_color }}>
              {showAll ? 'Show fewer facilities' : 'Show all facilities'}
            </button>
          )}
        </div>
        <div>
          <h3 className="text-3xl font-bold mb-4" style={heading}>{s.facilities_title}</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 lg:gap-4">
            {shown.map((f, i) => {
              const Icon = ICONS[f.icon] || Leaf;
              return (
                <div key={i} className="bg-white border flex flex-col items-center justify-center gap-3 py-8 px-3 text-center" style={{ borderColor: `${theme.primary_color}80` }}>
                  <Icon className="w-6 h-6" strokeWidth={1.5} style={{ color: s.text_color || theme.primary_color }} />
                  <span className="font-bold" style={{ color: s.text_color || theme.primary_color }}>{f.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}